import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Details } from 'src/app/web/interfaces/project/milestones/details';
import { ApiServiceProject } from '../../../apis/ApiServiceProject';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ListMilestones } from '../../../interfaces/project/list/projectDetailsDto';
import { map } from 'rxjs/operators'
import { stageProject } from 'src/app/web/interfaces/project/stages/stageProject';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { formatDate } from '@angular/common';
import { CreateMilestone } from 'src/app/web/interfaces/project/milestones/create-milestone';
import { ErrorService } from 'src/app/shared/services/errors.service';
import * as moment from 'moment';

@Component({
  selector: 'app-update-milestone',
  templateUrl: './update-milestone.component.html',
  styleUrls: ['./update-milestone.component.scss']
})
export class UpdateMilestoneComponent implements OnInit {
  title = "Datos"
  idProject: number;
  idMilestone: number;
  projectStages: stageProject[] = [];
  listMilestones: ListMilestones[] = [];
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  createMilestoneForm: FormGroup;
  createMilestone: CreateMilestone;
  detailsMilestone: Details = {} as Details
  private apiService: ApiServiceProject;
  searchForm: FormGroup;
  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private errorService:ErrorService
  ) {
    this.route.params.subscribe((params) => {
      this.idProject = params['id_project'];
      this.idMilestone = params['id_milestone'];
    });
  }

  ngOnInit(): void {
    this.createMilestoneForm = this.fb.group({
      id:0,
      project_stages_id: [0],
      title: [''],
      end_date: [''],
      start_date: [''],
      state: [0],
      description: [''],
    });
    this.apiService = new ApiServiceProject(this.http);
    this.spinner.show();
    this.apiService.getService('project-view-milestone?id_project=' + this.idProject).subscribe({
      next: (rs: any) => {
        if (rs.code == null) {
          // si la respuesta no tiene error pero no tiene data se manda un mensaje de error y se retorna al home
          if (rs == '' || rs == null) {
            this.spinner.hide();
            Swal.fire({
              title: 'No se encontraron registros',
              text: '',
              icon: 'info',
              confirmButtonText: 'Aceptar',
              heightAuto: false
            }).then((res) => {
              if (res.isConfirmed || res.isDismissed) {
                this.router.navigate(['home']);
              }
            });
          }
          this.detailsMilestone = rs;
          this.spinner.hide();
          this.rerender();
        } else {

          this.spinner.hide();
          Swal.fire({
          title:  rs.error,
          text: '',
          icon: 'error',
          heightAuto: false
          });
        }
      },
      error: (error) => {
        this.errorService.error(error);
      },
    });

    localStorage.getItem("title");
    let datos = JSON.parse(localStorage.getItem("info-mtn"));

    this.idMilestone = datos.id

    let realStartDateDay =
      datos.dateStart.split('-')[2];
    let realStartDateMonth =
      datos.dateStart.split('-')[1];
    let realStartDateYear =
      datos.dateStart.split('-')[0];
    let realStartDate =
      realStartDateDay +
      '/' +
      realStartDateMonth +
      '/' +
      realStartDateYear;

    let realStartDateDayEnd =
      datos.dateEnd.split('-')[2];
    let realStartDateMonthEnd =
      datos.dateEnd.split('-')[1];
    let realStartDateYearEnd =
      datos.dateEnd.split('-')[0];
    let realStartDateEnd =
      realStartDateDayEnd +
      '/' +
      realStartDateMonthEnd +
      '/' +
      realStartDateYearEnd;
    this.createMilestoneForm.patchValue({
      project_stages_id: datos.projectStagesId,
      title: datos.name,
      end_date:  moment(realStartDateEnd).format("YYYY-MM-DD"),
      start_date: moment(realStartDate).format("YYYY-MM-DD"),
      state: datos.state,
      description: datos.description
    })

 

  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }
  get form() {
    return this.searchForm.controls;
  }



  formSubmit(): void {
    this.spinner.show();

    if (this.createMilestoneForm.value.project_stages_id === '' || this.createMilestoneForm.value.project_stages_id === 0 ) {
      this.spinner.hide();
      Swal.fire({title:'Debe seleccionar una etapa' ,text: '',icon: 'error',heightAuto: false});
      return;
    }

    if (this.createMilestoneForm.value.title === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe rellenar un título' ,text: '',icon: 'error',heightAuto: false});
      return;
    }

    if (this.createMilestoneForm.value.start_date === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe seleccionar una fecha de inicio' ,text: '',icon: 'error',heightAuto: false});
      return;
    }

    if (this.createMilestoneForm.value.end_date === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe seleccionar una fecha de fin' ,text: '',icon: 'error',heightAuto: false});
      return;
    }
    if (this.createMilestoneForm.value.state === ''|| this.createMilestoneForm.value.state === 0 ) {
      this.spinner.hide();
      Swal.fire({title:'Debe seleccionar un estado' ,text: '',icon: 'error',heightAuto: false});
      return;
    }

    if(moment( moment(this.createMilestoneForm.value.end_date).format("DD-MM-YYYY") ,"DD-MM-YYYY") < moment(  moment(this.createMilestoneForm.value.start_date).format("DD-MM-YYYY"),"DD-MM-YYYY")){
      this.spinner.hide();
      Swal.fire({title:'La fecha de inicio debe ser menor o igual a la fecha de termino.' ,text: '',icon: 'error',heightAuto: false});
      return;
    }
 
    
     this.createMilestone = this.createMilestoneForm.value;
     this.createMilestone.projects_id = Number(this.idProject);
     this.createMilestone.id = Number(this.idMilestone);
     this.createMilestone.project_stages_id = this.createMilestoneForm.value.project_stages_id;
     this.createMilestone.state = this.createMilestoneForm.value.state;


    this.createMilestone.start_date = moment(this.createMilestone.start_date).format("DD-MM-YYYY");

    this.createMilestone.end_date = moment(this.createMilestone.end_date).format("DD-MM-YYYY");


        this.apiService
        .postService('project-view-milestone-update',this.createMilestone)
        .subscribe({
          next: (data:any)=>{
            this.spinner.hide();
            Swal.fire({title:'Se ha modificado el hito correctamente',text: '',icon: 'success',heightAuto: false})
            .then(() =>[this.router.navigate(['/pdg/project/list/view',this.idProject])
          ]);
        },
        error: (error) => {
          this.errorService.error(error);
        },
        });
  }


}
